export default "__VITE_ASSET__Bot2EZbO__"